// Shared React hook for fetching, creating, updating, deleting records by type
import { useState, useEffect } from 'react';
import { fetchRecords, createOrUpdateRecord, deleteRecord } from '../services/AccountingReimbursementService';
import { useAuth } from '../../AuthProvider';


// Map type to transactionReference (matches TRANSACTION_REFERENCE)
const typeToTransactionReference = {
  expense: 'EXPENSE',
  personal: 'PERSONAL',
  account_payable: 'ACCOUNT_PAYABLE',
  tax: 'TAX',
  account_receivable: 'ACCOUNT_RECEIVABLE',
  sale: 'SALE',
  invoice: 'INVOICE',
  income: 'INCOME',
  deposit: 'DEPOSIT',
  reimbursements: 'REIMBURSEMENTS',
};


export default function useRecords(type) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      // For now, fetch all records (pending)
      const res = await fetchRecords(auth.token, 'pending', false, auth.additionalUserInfo.companyId);
      // Filter by transactionReference if needed
      const ref = typeToTransactionReference[type] || type;
      setData(res.data.filter(r => r.transactionReference === ref));
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); /* eslint-disable-next-line */ }, [type]);

  const create = async (record) => {
    // Use transactionReference from form value if present, else do not set
    let payload = { ...record };
    if (!payload.transactionReference && payload.purpose) {
      payload.transactionReference = payload.purpose;
    }
    await createOrUpdateRecord(payload, auth.token, false);
    fetchData();
  };
  const update = async (id, record) => {
    let payload = { ...record, reimbursementId: id };
    if (!payload.transactionReference && payload.purpose) {
      payload.transactionReference = payload.purpose;
    }
    await createOrUpdateRecord(payload, auth.token, true);
    fetchData();
  };
  const remove = async (id) => {
    await deleteRecord(id, auth.token);
    fetchData();
  };

  return { data, loading, error, fetchData, create, update, remove };
}
